export function createSkeleton(type: 'card' | 'detail' = 'card', count: number = 3): HTMLElement {
  const container = document.createElement('div');
  container.className = 'skeleton-container';

  for (let i = 0; i < count; i++) {
    const item = document.createElement('div');
    item.className = `skeleton skeleton-${type}`;
    
    if (type === 'card') {
      item.innerHTML = `
        <div class="skeleton-img"></div>
        <div class="skeleton-body">
          <div class="skeleton-line" style="width: 60%"></div>
          <div class="skeleton-line" style="width: 90%"></div>
          <div class="skeleton-line" style="width: 40%"></div>
        </div>
      `;
    } else {
      item.innerHTML = `
        <div class="skeleton-line" style="width: 70%; height: 28px; margin-bottom: 16px;"></div>
        <div class="skeleton-img" style="height: 200px;"></div>
        <div class="skeleton-body">
          <div class="skeleton-line" style="width: 100%"></div>
          <div class="skeleton-line" style="width: 100%"></div>
          <div class="skeleton-line" style="width: 65%"></div>
        </div>
      `;
    }
    
    container.appendChild(item);
  }

  return container;
}
